import { ProfileVersionSchema } from "../../common/models/schema/ProfileVersionSchema";
import {
  Card,
  CardContent,
  CardHeader,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  CircularProgress,
  Grid,
  Chip,
  Box,
  Button,
  Typography,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import PersonDetails from "./PersonDetails";
import { useState } from "react";

const ProfileVersion = ({
  version,
  handleRollback,
}: {
  version: ProfileVersionSchema;
  handleRollback: () => void | Promise<void>;
}) => {
  // Helper function to render field if not null/empty
  const [loading, setLoading] = useState(false);
  const handleRollbackPress = async () => {
    setLoading(true);
    try {
      await handleRollback();
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const renderField = (label: string, value: any) => {
    if (value === null || value === undefined || value === "") {
      return null;
    }

    return (
      <Grid size={{ xs: 12, sm: 6, md: 4 }}>
        <Typography variant="subtitle2" color="text.secondary">
          {label}
        </Typography>
        <Typography variant="body2" sx={{ wordBreak: "break-word" }}>
          {typeof value === "boolean" ? (value ? "Yes" : "No") : String(value)}
        </Typography>
      </Grid>
    );
  };

  // Helper function to format date
  const formatDate = (dateString: string) => {
    return new Date(dateString).toLocaleString();
  };

  return (
    <Card sx={{ mb: 2, width: "100%" }}>
      <CardHeader
        title={`Version ${version.version}`}
        subheader={
          <Box>
            <Typography variant="caption" color="text.secondary">
              NationBuilder ID: {version.nationbuilder_id}
            </Typography>
          </Box>
        }
        action={
          <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap" }}>
            {version.profile_data.tags &&
              version.profile_data.tags.length > 0 && (
                <Box
                  sx={{
                    display: "flex",
                    gap: 0.5,
                    flexWrap: "wrap",
                    maxWidth: 300,
                    // width: "100%",
                  }}
                >
                  {/* {version.profile_data.tags.map((tag, index) => (
                  <Chip
                    key={`${tag.tag_id}-${index}`}
                    label={tag.tag_name}
                    size="small"
                    color="primary"
                    variant="outlined"
                  />
                ))} */}
                </Box>
              )}
          </Box>
        }
      />

      <CardContent>
        <Grid container spacing={2}>
          {renderField("Version ID", version.id)}
          {renderField("Created By", version.created_by)}
          {renderField("Information Source", version.information_source)}
        </Grid>

        {version.information_source === "manual" && (
          <Grid container spacing={2} sx={{ mt: 2 }}>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Button
                variant="contained"
                color="primary"
                onClick={handleRollbackPress}
                disabled={loading}
              >
                {loading ? <CircularProgress size={24} /> : "Rollback"}
              </Button>
            </Grid>
          </Grid>
        )}

        {/* Accordion for extended person info */}
        <Accordion sx={{ mt: 2 }}>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="person-details-content"
            id="person-details-header"
          >
            <Typography variant="h6">View Extended Person Details</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <PersonDetails person={version.profile_data.person} />

            {/* Tags Section */}
            {version.profile_data.tags &&
              version.profile_data.tags.length > 0 && (
                <Box sx={{ mt: 3 }}>
                  <Typography variant="h6" gutterBottom>
                    Tags
                  </Typography>
                  <Box
                    sx={{
                      display: "flex",
                      gap: 1,
                      flexWrap: "wrap",
                    }}
                  >
                    {version.profile_data.tags.map((tag, index) => (
                      <Chip
                        key={`${tag.tag_id}-${index}`}
                        label={tag.tag_name}
                        size="medium"
                        color="primary"
                        variant="filled"
                      />
                    ))}
                  </Box>
                </Box>
              )}
          </AccordionDetails>
        </Accordion>
      </CardContent>
    </Card>
  );
};

export default ProfileVersion;
